"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveFindExpression = void 0;
var arrays_1 = require("../arrays");
var __1 = require("../");
var utils_1 = require("../../utils");
var resolveFindExpression = function (expression, context) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, array, _b, condition, arrayValue, conditionValue, conditionFn, conditionQuery_1, conditionMatch_1, index, value, check;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = expression.array, array = _a === void 0 ? [] : _a, _b = expression.condition, condition = _b === void 0 ? {} : _b;
                return [4 /*yield*/, arrays_1.resolveArrayExpression(array, context)];
            case 1:
                arrayValue = _c.sent();
                return [4 /*yield*/, __1.resolveExpression(condition, context)];
            case 2:
                conditionValue = _c.sent();
                switch (typeof conditionValue) {
                    case 'function':
                        conditionFn = conditionValue;
                        break;
                    case 'object':
                        conditionQuery_1 = conditionValue.query, conditionMatch_1 = conditionValue.match;
                        conditionFn = function (arrayElement) { return __awaiter(void 0, void 0, void 0, function () {
                            var queryResult;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        queryResult = arrayElement;
                                        if (!conditionQuery_1) return [3 /*break*/, 2];
                                        return [4 /*yield*/, utils_1.fetch(arrayElement, conditionQuery_1)];
                                    case 1:
                                        queryResult = _a.sent();
                                        _a.label = 2;
                                    case 2: 
                                    // compare them
                                    return [2 /*return*/, queryResult === conditionMatch_1];
                                }
                            });
                        }); };
                        break;
                    default:
                        throw new Error([
                            'Could not resolve find expression.',
                            'condition must either be a function or an object with query and match'
                        ].join('\n'));
                }
                index = 0;
                _c.label = 3;
            case 3:
                if (!(index < arrayValue.length)) return [3 /*break*/, 6];
                value = arrayValue[index];
                return [4 /*yield*/, conditionFn(value)];
            case 4:
                check = _c.sent();
                if (check) {
                    // return both found index and the corresponding array value
                    return [2 /*return*/, {
                            index: index,
                            value: value
                        }];
                }
                _c.label = 5;
            case 5:
                index += 1;
                return [3 /*break*/, 3];
            case 6: return [2 /*return*/, {
                    index: -1
                }];
        }
    });
}); };
exports.resolveFindExpression = resolveFindExpression;
//# sourceMappingURL=index.js.map